import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
import MasonryWall from '@yeger/vue2-masonry-wall'
import router from './router'
import './assets/css/font.css' 


Vue.use(ElementUI);
Vue.use(MasonryWall);

Vue.config.productionTip = false

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
